module.exports = __webpack_public_path__ + "static/media/everyday_digital_weekend_papers_may_2024.2a0295d7.webp";